/**
 * Moldura da tela de entrada (design "pharu-erp-login", out/2026).
 *
 * Rota de layout para /login e /mfa-verify: a cena do fluxo, o topo e o
 * rodapé ficam montados entre as duas etapas e só o painel do meio troca
 * (como no design), em vez de a página inteira piscar e recomeçar.
 *
 * A paleta é a do design (.e escuro / .e.light claro), escolhida pelo tema
 * EFETIVO do app — o mesmo que o botão sol/lua alterna.
 */
import React from "react";
import { Outlet } from "react-router-dom";

import { useThemeToggle } from "../../../context/ThemeContext";
import CenaDoFluxo from "./CenaDoFluxo";
import PainelUltrawide from "./PainelUltrawide";
import Rodape from "./Rodape";
import Topo from "./Topo";
import useStatusDoServidor from "./useStatusDoServidor";
import { marcaDaEntrada } from "./marca";
import "./entrada.css";

const DESTAQUE_ESCURO = "#38bdf8";
const DESTAQUE_CLARO = "#0369a1";

export default function TelaDeEntrada({ children }) {
  const tema = useThemeToggle();
  const escuro = tema ? Boolean(tema.isDark) : true;
  const status = useStatusDoServidor();
  const marca = marcaDaEntrada();

  return (
    <div className={escuro ? "e" : "e light"} data-testid="tela-de-entrada" style={{ "--a": escuro ? DESTAQUE_ESCURO : DESTAQUE_CLARO }}>
      <div className="e-side">
        <Topo marca={marca} status={status} escuro={escuro} />
        <main className="e-auth">{children || <Outlet />}</main>
        <Rodape marca={marca} />
      </div>
      <CenaDoFluxo />
      <PainelUltrawide marca={marca} status={status} />
    </div>
  );
}
